import { Box, Typography } from '@mui/material'

import { TAResponseProps } from 'types/TextAnalysis'
import { getOwnerType } from '../Helpers/Helper'

export const renderCardMetricsContent = ({
  associations,
  metadata,
}: TAResponseProps) => {
  const { owner } = associations
  const ownerType = getOwnerType(owner)

  if (ownerType === 'survey') return null

  if (ownerType === 'brainstormer') {
    const { likes_count, comments_count } = metadata

    const likes = likes_count > 0 ? `Likes: ${likes_count}` : null
    const comments = comments_count > 0 ? `Comments: ${comments_count}` : null

    if (!likes && !comments) return null

    return (
      <Box display="flex" gap="1rem" data-testid="ta-footer-metrics">
        {likes && <Typography key="likes">{likes}</Typography>}
        {comments && <Typography key="comments">{comments}</Typography>}
      </Box>
    )
  }

  return null
}
